import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-wo-special-instructions',
  templateUrl: 'WorkOrderSpecialInstructions.component.html',
  styleUrls: ['WorkOrderSpecialInstructions.component.scss']
})
export class WorkOrderSpecialInstructionsComponent {
  isInstruction: Boolean;
  @Input() researchInstructions: string;

  constructor( ) { }
 }



// WEBPACK FOOTER //
// ./src/app/workOrderSpecialInstructions/workOrderSpecialInstructions.component.ts